// ————————————————————————————————————————————— LIB. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————————— UTIL. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

import convert_floatToTimeString from "../../../../../app/baseUtilities/convert/convert_floatToTimeString";

// ———————————————————————————————————————————— ASSETS ———————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

const logArgs = { eventName: "stChH_stateChange", inline: true, disabled: true };
const msgs = {
  stateChange: (CHANGE) => [`playbackTime: ${CHANGE}`],
  no_change: ["No change to state provided."],
  no_someEl: ["state change hdl.", "stateChange", "no some el. found"],
};

// —————————————————————————————————————————— HDL. DEF. ——————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

export default function stChH_playbackTime(CHANGES) {
  if (!("playbackTime" in CHANGES)) return this.logger("error", msgs.no_change, "error", logArgs);

  //////////////////////////////////////////// Setup /////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  const { playbackTime } = CHANGES;
  const { playbackTimeDisplay } = this.ref;
  this.logger("state-change", msgs.stateChange(playbackTime), "default", logArgs);

  //////////////////////////////////// State change execution ////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  ////////////////////////// Playback time display updt. //////////////////////////
  ////////////////////////////////////////////////////////////////////////

  if (playbackTimeDisplay) {
    const textEl = playbackTimeDisplay.querySelector("span");
    textEl.textContent = convert_floatToTimeString(playbackTime);
  }
}

// ———————————————————————————————————————————————————————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //
